<template>
    <Modal modal-name="ask-question-login" size="md" :title="title">
        <!-- FIXME Create modal for login -->
        <div class="modal-body" v-html="$t('discussions.login.mustLogin')"></div>
    </Modal>
</template>

<script lang="ts">
import Modal from '~/components/Modal.vue'

export default {
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: 'Přihlásit se',
        },
    },
}
</script>
